import ResponseModel from '../responsemodel/ResponseModel'
import DomainModel from '../../models/DomainModel'

export default abstract class DataMapper<RM extends ResponseModel, DM extends DomainModel[]> {
  abstract map(rm: RM): DM
}
